import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Form, Button, Row, Col, Card } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import {
  fetchRestaurantDetails,
  tablesToChange as fetchTablesToChange,
  fetchConnectTablesConfig,
  changeTables,
  fetchTables,
} from "../actions/restaurantActions";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TablesModal from "../components/ChangeTables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTriangleExclamation,
  faShareFromSquare,
  faClock,
  faHouse,
} from "@fortawesome/free-solid-svg-icons";
import {
  fetchOpenTime,
  fetchCreateReservation,
  fetchReservationLimitPeopleBaby,
  fetchEditReservation,
  fetchReservationCustomerMenu,
  checkIfrestaurantIsOpenToday,
  getRestaurantTimeZone,
  ResetReservation,
  fetchCancelReservation,
  fetchReservationActive,
} from "../actions/reservationsActions";
import styled from "styled-components";
import CustomDatePicker from "../components/CustomDatePicker";
import CustomSelect from "../components/SelectableCustom";
import Loader from "../components/Loader";
import TermsAndConditions from "../components/TermsAndConditions";
import ScrollInputOptions from "../components/ScrollInputOptions";
import StepThreeReservations from "../components/StepThreeReservations";
import AnimatedCheck from "../components/CheckMarkAnimation";
import { isValidNumber } from "libphonenumber-js";
import StepBar from "../components/StepBar";
import NumberOfPeopleSelector from "../components/NumberOfPeopleSelector";
import ChooseTime from "../components/ChooseTime";
import moment from "moment-timezone";
import { is } from "date-fns/locale";
import { TableSvgIcon } from "../icons/SvgIcons";
import { ModernButton, ModalOverlay } from "../components/DefaultImports";
import { ConfirmationModal } from "../components/ConfirmationModal";
import SwitchOnAndOff from "../components/SwitchOnAndOff";

const WidgetScreenFrame = styled.div`
  width: 100%;
  height: ${({ $widgetMode }) => ($widgetMode ? "100%" : "600px")};
  max-height: ${({ $widgetMode }) => ($widgetMode ? "100%" : "none")};
  display: ${({ $widgetMode }) => ($widgetMode ? "flex" : "block")};
  flex-direction: ${({ $widgetMode }) => ($widgetMode ? "column" : "initial")};
  overflow: ${({ $widgetMode }) => ($widgetMode ? "hidden" : "visible")};
  background: ${({ $widgetMode, $backgroundColor }) =>
    $widgetMode ? $backgroundColor : "transparent"};
  color: ${({ $widgetDark }) => ($widgetDark ? "#f6f1e8" : "#333333")};
  box-sizing: border-box;
  padding: 0;
`;
const Wrapper = styled(Container)`
  width: ${({ no_border, $widgetMode }) =>
    no_border || $widgetMode ? "100%" : "auto"};

  ${({ no_border, $widgetMode }) =>
    !no_border && !$widgetMode ? "max-width: 500px;" : ""}

  ${({ $widgetMode }) => ($widgetMode ? "max-width: 720px;" : "")}

  --widget-main-color: ${({ $mainColor }) => $mainColor || "#ee754c"};
  --widget-bg: ${({ $widgetMode, $backgroundColor }) =>
    $widgetMode ? $backgroundColor : "#ffffff"};
  --widget-text-color: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark ? "#f6f1e8" : "#343a38"};
  --widget-muted-text: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark ? "rgba(246, 241, 232, 0.68)" : "#6f7c79"};
  --widget-border-color: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark
      ? "rgba(255, 255, 255, 0.18)"
      : "rgba(153, 176, 173, 0.32)"};
  --widget-soft-bg: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark ? "rgba(255, 255, 255, 0.08)" : "#fafafa"};

  margin: ${({ no_border, $widgetMode }) =>
    no_border ? "0" : $widgetMode ? "0 auto" : "0 auto"};
  background-color: var(--widget-bg);
  color: var(--widget-text-color);
  padding: ${({ no_border, $widgetMode }) =>
    no_border
      ? "0 !important"
      : $widgetMode
        ? "16px !important"
        : "5px 5px 0px 5px"};
  border-radius: ${({ $widgetMode, $radius }) =>
    $widgetMode ? `${$radius}px` : "5px"};
  box-shadow: ${({ no_border, $widgetMode }) =>
    no_border || $widgetMode ? "none" : "0px 4px 6px rgba(0, 0, 0, 0.1)"};
  border: ${({ no_border, $widgetMode }) =>
    no_border || $widgetMode ? "none" : "1px solid #dbdbdb"};

  min-height: ${({ $widgetMode }) => ($widgetMode ? "0" : "600px")};
  height: ${({ $widgetMode }) => ($widgetMode ? "100%" : "600px")};
  max-height: ${({ $widgetMode }) => ($widgetMode ? "100%" : "none")};

  box-sizing: border-box;
  display: ${({ $widgetMode }) => ($widgetMode ? "flex" : "block")};
  flex-direction: ${({ $widgetMode }) => ($widgetMode ? "column" : "initial")};
  overflow: ${({ $widgetMode }) => ($widgetMode ? "hidden" : "visible")};

  @media (max-width: 576px) {
    padding: ${({ no_border, $widgetMode }) =>
      no_border ? "0 !important" : $widgetMode ? "10px !important" : "10px"};
  }
`;

const ModalBackgroundCheck = styled.div`
  width: 50px;
  height: 50px;
  z-index: 1002;
`;

const ContainerCheck = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h3`
  width: 100%;
  margin: ${({ $widgetMode }) => ($widgetMode ? "4px 0 14px" : "0 0 20px")};
  font-size: ${({ $widgetMode }) => ($widgetMode ? "1.25rem" : "1.45rem")};
  font-weight: 750;
  text-transform: ${({ $widgetMode }) => ($widgetMode ? "none" : "uppercase")};
  color: ${({ $mainColor }) => $mainColor || "#99b0ad"};
  text-align: center;
  line-height: 1.2;
`;

const WidgetHeading = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 8px;
`;

const WidgetCustomTitle = styled.div`
  width: 100%;
  color: ${({ $mainColor }) => $mainColor || "#ee754c"};
  font-size: 1.05rem;
  font-weight: 750;
  line-height: 1.2;
  margin-bottom: 4px;
`;

const StyledCard = styled.div`
  width: 100%;
  min-width: 0;

  ${({ from_restaurant, $widgetMode }) =>
    !from_restaurant && !$widgetMode ? "max-width: 500px;" : ""}

  background-color: ${({ $widgetMode, $backgroundColor }) =>
    $widgetMode ? $backgroundColor : "white"};
  color: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark ? "#f6f1e8" : "#343a38"};
  padding: ${({ from_restaurant, $widgetMode }) =>
    from_restaurant || $widgetMode ? "0 !important" : "10px"};
  border-radius: ${({ $widgetMode }) => ($widgetMode ? "12px" : "5px")};
  border: none;
  box-shadow: none;
  box-sizing: border-box;
  text-align: center;

  ${({ $widgetMode }) =>
    $widgetMode
      ? `
        flex: 1 1 auto;
        min-height: 0;
        height: auto;
        max-height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        align-content: stretch;
        flex-wrap: nowrap;
      `
      : `
        min-height: 385px;
        height: auto;
        overflow: visible;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
      `}

  & > * {
    margin: 0;
    margin-bottom: ${({ $widgetMode }) => ($widgetMode ? "0" : "10px")};
  }
`;
const ActionButtons = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;
`;

const DivFlexEnd = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
`;

const DivFlexStart = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: start;
`;

const Extras = styled.div`
  width: 100%;
  min-height: 42px;
  display: flex;
  align-items: center;
  padding: 9px 12px;
  margin-top: 4px;
  border-radius: 10px;
  gap: 10px;
  border: ${(props) =>
    props.isExtrasOpen ? "1px solid #EE754C" : "1px solid #d8dddb"};
  justify-content: space-between;
  cursor: pointer;
  color: ${(props) => (props.isExtrasOpen ? "#ffffff" : "#343a38")};
  background-color: ${(props) => (props.isExtrasOpen ? "#EE754C" : "white")};
  box-sizing: border-box;
`;

const CustomDateContainer = styled.div`
  position: fixed;
  width: auto;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  z-index: 5000;
`;

const ModalBackgroundToCustomDate = styled.div`
  position: fixed;
  z-index: 1005;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

const TablesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 12px;
  width: 100%;
`;

const TableBox = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f79574;
  color: white;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid gray;
`;

function getTableInfo(selectedTablesList, allTablesList) {
  let tableInfo = {};

  Object.keys(selectedTablesList).forEach((zoneName) => {
    const tableNumbers = selectedTablesList[zoneName].map(
      (table) => table.number,
    );

    allTablesList.forEach((tablesInZone) => {
      if (tablesInZone[0] === zoneName) {
        tableNumbers.forEach((tableNumber) => {
          const tableDetails = tablesInZone.find(
            (table) => table.split(";")[0] === tableNumber,
          );
          if (tableDetails) {
            if (tableInfo[zoneName]) {
              tableInfo[zoneName].push(tableDetails);
            } else {
              tableInfo[zoneName] = [tableDetails];
            }
          }
        });
      }
    });
  });

  let tableInfoList = [];
  Object.keys(tableInfo).forEach((zone) => {
    tableInfoList.push([zone, ...tableInfo[zone]]);
  });

  return tableInfoList;
}

function getTableInfoPk(selectedTablesList) {
  let tablePKs = [];

  Object.values(selectedTablesList).forEach((tablesInZone) => {
    tablesInZone.forEach((table) => {
      tablePKs.push(String(table.number));
    });
  });

  return tablePKs;
}

function listToSelectedTablesFormat(zoneName, tableNumbers) {
  if (!Array.isArray(tableNumbers)) {
    throw new Error("Expected parameter to be an array");
  }

  const tables = tableNumbers.map((tableNumber) => ({
    number: tableNumber,
    status: "0",
  }));

  return {
    [zoneName]: tables,
  };
}

const ReservationScreen = ({
  from_restaurant = false,
  creating = true,
  isEditModalOpen = false,
  setIsEditModalOpen = false,
  restaurantId = false,
  token_from_restaurant = false,
  handleCloseReservationModal,
  setCreating,
  reset,
  editModalRef,
  setTokens = false,
  reservation_or_waiting_list = "reservation",
  setReservationHasBeenModified,
  reservationHasBeenModified,
  modalReservationModifyReservation,
  setModalReservationModifyReservation,
  no_border = false,
  reservationRetry = false,
  setReservationRetry,
  widgetMode: widgetModeProp = false,
  widgetDark = false,
}) => {
  const id = useParams();

  const location = useLocation();

  const queryParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  const isValidCssColor = (value) => {
    if (!value) return false;

    return (
      /^#[0-9A-Fa-f]{6}$/.test(value) ||
      /^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$/.test(value) ||
      /^rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*(0|1|0?\.\d+)\s*\)$/.test(
        value,
      )
    );
  };

  const normalizeCssColor = (value, fallback) => {
    return isValidCssColor(value) ? value : fallback;
  };

  const widgetSettings = {
    title: queryParams.get("title") || "Reservar mesa",
    showRestaurantName: queryParams.get("showName") !== "0",
    mainColor: normalizeCssColor(
      queryParams.get("main") ||
        queryParams.get("primary") ||
        queryParams.get("button"),
      "#EE754C",
    ),
    backgroundColor: normalizeCssColor(queryParams.get("bg"), "#FFFFFF"),
    radius: Number(queryParams.get("radius") || 14),
  };
  const routeToken =
    id.token && id.token !== "no_token" && id.token !== "null"
      ? id.token
      : false;

  const routeWidgetMode = id.from_whom === "widget";
  const widgetMode = Boolean(widgetModeProp || routeWidgetMode);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [token, setToken] = useState(
    token_from_restaurant ? token_from_restaurant : routeToken,
  );

  const [restaurant_id, setRestaurant_id] = useState(
    id.restaurant_id ? id.restaurant_id : restaurantId,
  );

  const [startDateWS, setStartDateWS] = useState(false);
  const [babyChairs, setBabyChairs] = useState(false);
  const [numBabyChairs, setNumBabyChairs] = useState(0);
  const [time, setTime] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [numPeople, setNumPeople] = useState(0);
  const [estimatedTime, setEstimatedTime] = useState("");
  const [message, setMessage] = useState("");
  const [restaurantNote, setRestaurantNote] = useState("");
  const maxMessageLength = 150;
  const [accessability, setAccessability] = useState("");
  const [accessabilities, setAccessabilities] = useState(["Cadeira de rodas"]);
  const [tablesUsed, setTablesUsed] = useState([]);

  const [usedTablesDic, setUsedTablesDic] = useState({});
  const [fullName, setFullName] = useState("");
  const [placeOfTable, setPlaceOfTable] = useState("");
  const [placeOfTableWS, setPlaceOfTableWS] = useState(false);
  const [fourthStage, setFourthStage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const [countryCode, setCountryCode] = useState("us");
  const [countryCodeNumber, setCountryCodeNumber] = useState("351");
  const [phone, setPhone] = useState("");
  const [phoneWithoutCountryCode, setPhoneWithoutCountryCode] = useState("");

  const [email, setEmail] = useState("");
  const [emailWS, setTheEmailWS] = useState(false);

  const [subscription, setSubscription] = useState({});
  const [cd, setCd] = useState("");
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [acceptTermsWS, setAcceptTermsWS] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [fullRestaurant, setFullRestaurant] = useState(false);
  const [isExtrasOpen, setIsExtrasOpen] = useState(false);
  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [isAccessOpen, setIsAccessOpen] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [editingStartFalse, setEditingStartFalse] = useState(true);
  const [showTablesModal, setShowTablesModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [ignoreLimitations, setIgnoreLimitations] = useState(false);
  const [selectedTablesSave, setSelectedTablesSave] = useState(false);
  const [isTablesChangedManually, setIsTablesChangedManually] = useState(false);
  const [reservationObj, setReservationObj] = useState({});
  const [isReservationChanged, setIsReservationChanged] = useState(false);
  const [accept_and_notify_client, setAccept_and_notify_client] =
    useState(false);
  const [accept_edit_modal, setAccept_edit_modal] = useState(false);

  const [verifyReservationFields, setVerifyReservationFields] = useState(false);

  const [enoughSeatsReservation, setEnoughSeatsReservation] = useState(false);
  const [modalWarningNotEnoughSeats, setModalWarningNotEnoughSeats] =
    useState(false);

  const [showModalWarning, setShowModalWarning] = useState(false);
  const [fullyBooked, setFullyBooked] = useState(false);
  const [isChangesMade, setIsChangesMade] = useState(false);
  const [isAlertFullyBookedOrCrowd, setIsAlertFullyBookedOrCrowd] =
    useState(false);

  const [autoOrManualTables, setAutoOrManualTables] = useState(
    creating ? "Atribuição automática de mesas" : "Atribuição manual de mesas",
  );

  const [update, setUpdate] = useState(0);

  const reservationCancel = useSelector((state) => state.cancelReservation);
  const { cancelMessage, isLoadingCancel } = reservationCancel;

  const reservation_info = useSelector(
    (state) => state.reservationCustomersMenu,
  );
  const { reservation, isLoading: isLoadingReservation = false } =
    reservation_info;

  const editReservations = useSelector((state) => state.editReservation);
  const { editReservation, isLoadingEditReservation } = editReservations;

  const openTimes = useSelector((state) => state.openTime);
  const { openTime, isLoadingOpenTime, errorOpenTime } = openTimes;

  const LimitsPB = useSelector((state) => state.reservationLimitsPeopleBaby);
  const { limitPeopleBaby } = LimitsPB;

  const reservation_createdd = useSelector((state) => state.createReservation);
  const {
    reservation_created,
    toastCreateUpdate,
    isLoading,
    error,
    createReservationFailed,
    createReservationSuccess,
  } = reservation_createdd;

  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurantDetails;

  const tablesToChange = useSelector((state) => state.availableTablesToChange);
  const { tables = [], isLoadingTables, errorTables } = tablesToChange;

  const all_tables_wait = useSelector((state) => state.restaurantTables);
  const { tables: all_tables = false, isLoading: isLoadingAllTables = false } =
    all_tables_wait;

  const [initialLoading, setInitialLoading] = useState(true);

  const [notifyCustomerModal, setNotifyCustomerModal] = useState(false);
  const [isSubmittingNotifyChoice, setIsSubmittingNotifyChoice] =
    useState(false);

  useEffect(() => {
    if (reservationRetry === true) {
      const reservationInfo = error?.reservationInfo;
      if (reservationInfo) {
        setFullName(reservationInfo.name);

        const dateObject = new Date(reservationInfo.date);
        setStartDate(dateObject);

        if (
          reservationInfo.table_place_preference !== null &&
          reservationInfo.table_place_preference !== ""
        ) {
          setPlaceOfTable(
            reservationInfo.placeOfTables
              ? reservationInfo.placeOfTables
              : "Sem Sala",
          );
        } else {
          setPlaceOfTable("");
        }

        setTime(reservationInfo.time);
        setEstimatedTime(reservationInfo.estimatedtime);
        setMessage(reservationInfo.message);
        setNumPeople(reservationInfo.numberOfPeople);
        setCountryCodeNumber(reservationInfo.country_code);
        setPhone(reservationInfo.phone_number);
        setEmail(reservationInfo.email);
        setSelectedTablesSave(false);

        setAccessability(
          reservationInfo.accessability === "wheel_chair"
            ? "Cadeira de rodas"
            : "Não precisa",
        );

        setRestaurantNote(reservationInfo.restaurant_note);
        setNumBabyChairs(reservationInfo.baby_chair);
        setBabyChairs(reservationInfo.baby_chair > 0);

        if (reservationInfo.accessability !== "not_needed") {
          setIsAccessOpen(true);
        } else {
          setIsAccessOpen(false);
        }
      }
      setCurrentStep(3);
    }
  }, [error]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!from_restaurant) {
      dispatch(fetchReservationActive());
    }
  }, [from_restaurant]);

  useEffect(() => {
    if (
      Array.isArray(tablesUsed) &&
      tablesUsed[0] == "" &&
      tablesUsed.length > 1
    ) {
      setTablesUsed(tablesUsed.slice(1, tablesUsed.length));
    }
  }, [tablesUsed]);

  useEffect(() => {
    if (token) {
      setEditingStartFalse(true);
    } else {
      setEditingStartFalse(true);
    }
  }, [token, editingStartFalse]);

  useEffect(() => {
    dispatch(fetchTables(restaurant_id));
    dispatch(fetchConnectTablesConfig(restaurant_id));
  }, [restaurants]);

  useEffect(() => {
    if (restaurantId) {
      setRestaurant_id(restaurantId);
    }
  }, [restaurantId]);

  const getDateInTimezone = (timezone) => {
    const now = new Date();
    const dateInTimezone = new Date(
      now.toLocaleString("en-US", { timeZone: timezone }),
    );

    dateInTimezone.setHours(0, 0, 0, 0);

    return dateInTimezone;
  };

  const getTimezone = (timezone) => {
    const now = new Date();
    const dateInTimezone = new Date(
      now.toLocaleString("en-US", { timeZone: timezone }),
    );

    const hours = dateInTimezone.getHours().toString().padStart(2, "0");
    const minutes = dateInTimezone.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  const isWithinOneDay = (reservationDate) => {
    const now = new Date();

    const reservation = new Date(reservationDate);

    if (isNaN(reservation)) {
      return false;
    }

    now.setHours(0, 0, 0, 0);
    reservation.setHours(0, 0, 0, 0);

    const diffInMs = reservation - now;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays >= -1;
  };

  useEffect(() => {
    if (!reservation && reservationRetry === false) {
      setToken("");
      setEstimatedTime("");
      setBabyChairs(false);
      setNumBabyChairs(0);
      setMessage("");
      setEmail("");
      setNumPeople(0);
      setTablesUsed([]);
      setSelectedTablesSave(false);
      setAccessability("");
      setPlaceOfTable("");
      setUsedTablesDic({});
      setStartDate(null);
      setTime(null);
      setRestaurantNote("");

      if (restaurants && reservation_or_waiting_list === "waiting_list") {
        setStartDate(getDateInTimezone(restaurants.timezone));
        setPlaceOfTable("Não definir sala");
        setTime(getTimezone(restaurants.timezone));
        setCurrentStep(1);
      } else {
        setCurrentStep(0);
      }

      if (from_restaurant) {
        setFullName("");
        setPhoneWithoutCountryCode("");
      }
    }
  }, [creating, token, reservation_or_waiting_list, reservation]);

  const [fullNameWS, setFullNameWS] = useState(false);
  const [numPeopleWS, setNumPeopleWS] = useState(false);
  const [timeWS, setTimeWS] = useState(false);
  const [phoneWS, setPhoneWS] = useState(false);

  useEffect(() => {
    dispatch(checkIfrestaurantIsOpenToday(restaurant_id));
    dispatch(getRestaurantTimeZone(restaurant_id));
  }, [from_restaurant, restaurant_id]);

  useEffect(() => {
    if (!restaurant_id || !startDate || !time || !numPeople) return;

    dispatch(
      fetchReservationLimitPeopleBaby(
        restaurant_id,
        startDate,
        time,
        numPeople,
        token || "no_token",
      ),
    );
  }, [startDate, time, restaurant_id, numPeople, token]);

  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (!creating) {
      setCurrentStep(3);
    }
  }, []);

  const parseTime = (timeString) => {
    if (
      !timeString ||
      typeof timeString !== "string" ||
      !timeString.includes(":")
    ) {
      console.warn("⛔ Invalid time string passed to parseTime:", timeString);
      return NaN;
    }

    const [hours, minutes] = timeString.split(":").map(Number);
    return hours * 60 + minutes;
  };

  useEffect(() => {
    if (!from_restaurant) {
      dispatch(fetchRestaurantDetails(restaurant_id));
    }
  }, [dispatch, restaurant_id]);

  useEffect(() => {
    if (token_from_restaurant) {
      setToken(token_from_restaurant);
    } else {
      setToken(routeToken);
    }

    if (!reservation) {
      setSelectedTablesSave(false);
    }
  }, [token_from_restaurant, routeToken, reservation]);

  useEffect(() => {
    if (!creating && token != "") {
      dispatch(fetchReservationCustomerMenu(token, "no"));
    } else {
      dispatch(ResetReservation());
    }
  }, [creating, token]);

  useEffect(() => {
    if (!creating && token != "") {
      if (reservation && restaurant_id !== reservation.restaurant) {
        setRestaurant_id(reservation.restaurant);
      }
    }
  }, [reservation]);

  useEffect(() => {
    let phoneWithoutCountryCoda;
    if (reservation && reservation.phone_number) {
      const countryCodeLength = reservation.country_code.length;
      let phoneNumber = reservation.phone_number;

      if (phoneNumber[0] === "+") {
        phoneNumber = phoneNumber.slice(1);
      }

      phoneWithoutCountryCoda = phoneNumber.slice(countryCodeLength);
    }

    function deepEqual(obj1, obj2) {
      if (obj1 === obj2) return true;

      if (
        typeof obj1 !== "object" ||
        obj1 === null ||
        typeof obj2 !== "object" ||
        obj2 === null
      ) {
        return false;
      }

      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) return false;

      for (let key of keys1) {
        if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
          return false;
        }
      }

      return true;
    }

    if (
      (reservation && !creating && !deepEqual(reservation, reservationObj)) ||
      (reservation && fullName !== reservation.full_name)
    ) {
      setFullName(reservation.full_name);
      const dateObject = new Date(reservation.date);
      setStartDate(dateObject);

      if (
        reservation.table_place_preference !== null ||
        reservation.table_place_preference !== ""
      ) {
        setPlaceOfTable(
          reservation.table_place_preference
            ? reservation.table_place_preference.place_of_table
            : "Não definir sala",
        );
      } else {
        setPlaceOfTable("");
      }

      setTime(reservation.time);
      setEstimatedTime(reservation.estimatedtime);
      setMessage(reservation.message);
      setNumPeople(reservation.number_of_people);
      setTablesUsed(reservation.tablesused.split(","));
      setCountryCodeNumber(reservation.country_code);
      setPhone(reservation.phone_number);
      setPhoneWithoutCountryCode(phoneWithoutCountryCoda);
      setEmail(reservation.email);
      setSelectedTablesSave(false);

      setAccessability(
        reservation.accessability === "wheel_chair"
          ? "Cadeira de rodas"
          : "Não precisa",
      );

      setRestaurantNote(reservation.restaurant_note);
      setNumBabyChairs(reservation.baby_chair);

      if (reservation.baby_chair > 0) {
        setBabyChairs(true);
      } else {
        setBabyChairs(false);
      }

      if (reservation.accessability != "not_needed") {
        setIsAccessOpen(true);
      } else {
        setIsAccessOpen(false);
      }

      let usedTabless;
      if ((ignoreLimitations && creating) || reservation.tablesused === "") {
        usedTabless = "no_tables";
      } else {
        usedTabless = reservation.tablesused;
      }

      const inputDate = new Date(dateObject);
      dispatch(
        fetchTablesToChange(
          restaurant_id,
          `${inputDate.getFullYear()}-${String(
            inputDate.getMonth() + 1,
          ).padStart(2, "0")}-${String(inputDate.getDate()).padStart(2, "0")}`,
          reservation.time,
          reservation.token,
          reservation.number_of_people,
        ),
      );

      setReservationObj(reservation);
    }
  }, [reservation, token, creating]);

  useEffect(() => {
    if (reservation) {
      let usedTablesss = reservation.tablesused.split(",");
      let selectedTablesFormat = {};

      if (Array.isArray(usedTablesss)) {
        selectedTablesFormat = listToSelectedTablesFormat(
          reservation.table_place_preference
            ? reservation.table_place_preference.place_of_table
            : "Não definir sala",
          usedTablesss,
        );
      }

      setUsedTablesDic(selectedTablesFormat);
    }
  }, [reservation]);

  useEffect(() => {
    console.log(
      "i was selectedTablesSave: ",
      selectedTablesSave,
      "usedTablesDic: ",
      usedTablesDic,
    );
  }, [selectedTablesSave, usedTablesDic]);

  const handleShowTablesModal = (show = true) => {
    let usedTablesss = tablesUsed;
    let selectedTablesFormat = {};

    if (Array.isArray(usedTablesss)) {
      selectedTablesFormat = listToSelectedTablesFormat(
        placeOfTable,
        usedTablesss,
      );
    }

    setUsedTablesDic(selectedTablesFormat);

    const inputDate = new Date(startDate);

    dispatch(
      fetchTablesToChange(
        restaurant_id,
        `${inputDate.getFullYear()}-${String(inputDate.getMonth() + 1).padStart(
          2,
          "0",
        )}-${String(inputDate.getDate()).padStart(2, "0")}`,
        time,
        token === "" ? "no_token" : token,
        numPeople,
      ),
    );

    if (show) {
      setShowTablesModal(true);
    }
  };

  useEffect(() => {
    if (reservation_created && !from_restaurant && fullName === "") {
      setFullName(reservation_created.full_name);
      setEmail(reservation_created.email);
    }
  }, [reservation_created]);

  const changeStep = (step) => {
    if (step === 0) {
      setCurrentStep(step);
      if (!from_restaurant) {
        setStartDate(null);
        setTime(null);
        setNumPeople(0);
        setPlaceOfTable("");
      }
    }

    if (step === 1 && startDate != null) {
      setCurrentStep(step);

      if (!from_restaurant) {
        setTime(null);
        setNumPeople(0);
        setPlaceOfTable("");
      }
      setStartDateWS(false);
    } else {
      setStartDateWS(true);
    }

    if ((step === 2 && numPeople != "") || from_restaurant) {
      setCurrentStep(step);
    }

    if (step === 3 && time != "" && placeOfTable != "") {
      setCurrentStep(step);
      setTimeWS(false);
      setPlaceOfTableWS(false);
    } else {
      setTimeWS(true);
      setPlaceOfTableWS(true);
    }
  };

  const goBack = () => {
    if (currentStep === 3) {
      setErrorMessage(false);
    }
    setCurrentStep(currentStep - 1);
  };

  const verifyEmptyFields = (verify_for_edition = false) => {
    let verifyFields = true;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email) && !from_restaurant) {
      setTheEmailWS(true);
      verifyFields = false;
    } else {
      setTheEmailWS(false);
    }

    if (time === "" || time === null) {
      verifyFields = false;
      setTimeWS(true);
    } else {
      setTimeWS(false);
    }

    if (fullName === "") {
      verifyFields = false;
      setFullNameWS(true);
    } else {
      setFullNameWS(false);
    }

    if (placeOfTable === "") {
      verifyFields = false;
      setPlaceOfTableWS(true);
    } else {
      setPlaceOfTableWS(false);
    }

    if (isValidNumber("+" + phone) || from_restaurant) {
      setPhoneWS(false);
    } else {
      verifyFields = false;
      setPhoneWS(true);
    }

    if (numPeople === 0) {
      verifyFields = false;
      setNumPeopleWS(true);
    } else {
      setNumPeopleWS(false);
    }

    if (!verify_for_edition) {
      if (acceptTerms === false && from_restaurant === false) {
        verifyFields = false;
        setAcceptTermsWS(true);
      } else {
        setAcceptTermsWS(false);
      }
    }

    return verifyFields;
  };

  useEffect(() => {
    if (verifyEmptyFields()) {
      setVerifyReservationFields(true);
    } else {
      setVerifyReservationFields(false);
    }
  }, [startDate, numPeople, time, placeOfTable, fullName, email, phone]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let verifyFields = verifyEmptyFields();

    if (verifyFields === true) {
      setCurrentStep(currentStep + 1);

      if (creating === true && from_restaurant) {
        setCreating(false);
      }

      setShowCheck(true);
      setTimeout(() => {
        setShowCheck(false);
      }, 1700);

      const tables_used_list = getTableInfoPk(selectedTablesSave);

      dispatch(
        fetchCreateReservation(
          restaurant_id,
          startDate,
          numPeople,
          "Discontinued shift field",
          time,
          fullName,
          email,
          phone,
          countryCodeNumber,
          babyChairs ? numBabyChairs : 0,
          isMessageOpen ? message : "",
          placeOfTable.endsWith("/f") || placeOfTable.endsWith("/b")
            ? placeOfTable.slice(0, -2)
            : placeOfTable,
          subscription,
          accessability === "Cadeira de rodas" ? "wheel_chair" : "not_needed",
          from_restaurant,
          reservation_or_waiting_list,
          autoOrManualTables === "Atribuição automática de mesas"
            ? "automatic"
            : "not_automatic",
          tables_used_list,
          restaurantNote,
        ),
      );

      if (setIsEditModalOpen != false) {
        setIsEditModalOpen(false);
      }

      if (setTokens != false) {
        setTokens("");
      }
    }
  };

  const handleCheckWarningBeforeEdit = (e) => {
    e.preventDefault();

    if (
      !enoughSeatsReservation &&
      autoOrManualTables === "Atribuição manual de mesas"
    ) {
      setModalWarningNotEnoughSeats(true);
    } else if (isAlertFullyBookedOrCrowd) {
      setShowModalWarning(true);
    } else {
      if (creating) {
        handleSubmit(e);
      } else {
        if (
          from_restaurant &&
          (reservation.status === "pending_restaurant" ||
            reservation.status === "edited")
        ) {
          setAccept_edit_modal(true);
        } else {
          handleEdit(e);
        }
      }
    }
  };

  const shouldAskRestaurantEditNotifyModal = () => {
    if (!from_restaurant || creating) return false;

    if (
      reservation?.status === "pending_restaurant" ||
      reservation?.status === "edited"
    ) {
      return false;
    }

    return true;
  };

  const submitEditReservation = async (e, notifyCustomer = false) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }

    let verifyFields = verifyEmptyFields(true);

    if (verifyFields !== true) return;

    toast("Reserva Editada", { autoClose: 1000, zIndex: 1000 });

    setShowCheck(true);
    setTimeout(() => {
      setShowCheck(false);
    }, 1700);

    setCurrentStep(currentStep + 1);

    const tables_used_list = getTableInfoPk(selectedTablesSave);

    if (isReservationChanged) {
      dispatch(
        fetchEditReservation(
          token,
          restaurant_id,
          reservation.id,
          startDate,
          numPeople,
          "Discontinued shift field",
          time,
          fullName,
          phone,
          countryCodeNumber,
          numBabyChairs,
          message,
          placeOfTable.endsWith("/f") || placeOfTable.endsWith("/b")
            ? placeOfTable.slice(0, -2)
            : placeOfTable,
          subscription,
          accessability === "Cadeira de rodas" ? "wheel_chair" : "not_needed",
          ignoreLimitations,
          from_restaurant,
          from_restaurant && !creating ? true : isTablesChangedManually,
          tables_used_list,
          restaurantNote,
          notifyCustomer,
          email,
        ),
      );
    }

    if (!creating && token != "") {
      dispatch(fetchReservationCustomerMenu(token, "no"));
    } else {
      dispatch(ResetReservation());
    }

    setIsEditModalOpen(!isEditModalOpen);

    if (from_restaurant) {
      setTokens("");
    }
  };

  const handleNotifyCustomerChoice = async (notifyCustomer) => {
    try {
      setIsSubmittingNotifyChoice(true);
      setNotifyCustomerModal(false);

      await submitEditReservation(null, notifyCustomer);
    } finally {
      setIsSubmittingNotifyChoice(false);
    }
  };

  const handleEdit = (e) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }

    let verifyFields = verifyEmptyFields(true);

    if (verifyFields !== true) return;

    if (shouldAskRestaurantEditNotifyModal()) {
      setNotifyCustomerModal(true);
      return;
    }

    const notifyCustomer =
      from_restaurant &&
      !creating &&
      (reservation?.status === "pending_restaurant" ||
        reservation?.status === "edited")
        ? accept_and_notify_client
        : false;

    submitEditReservation(e, notifyCustomer);
  };

  useEffect(() => {
    if (!restaurant_id || !startDate || !numPeople) return;

    dispatch(
      fetchOpenTime(
        restaurant_id,
        startDate,
        numPeople,
        token === "no_id" ? false : token,
        ignoreLimitations,
      ),
    );

    if (initialLoading) return;

    const dateObject = new Date(startDate);
    if (Number.isNaN(dateObject.getTime())) return;

    if (!time) return;

    const formattedDate = `${dateObject.getFullYear()}-${String(
      dateObject.getMonth() + 1,
    ).padStart(2, "0")}-${String(dateObject.getDate()).padStart(2, "0")}`;

    const realToken = creating || !reservation ? "no_token" : reservation.token;

    const t = setTimeout(() => {
      dispatch(
        fetchTablesToChange(
          restaurant_id,
          formattedDate,
          time,
          realToken,
          numPeople,
        ),
      );
    }, 450);

    return () => clearTimeout(t);
  }, [
    dispatch,
    restaurant_id,
    startDate,
    numPeople,
    token,
    ignoreLimitations,
    time,
    initialLoading,
    creating,
    reservation,
  ]);

  const handleTimeChange = (newTime) => {
    setTime(newTime);
  };

  const handlePlaceOfTable = (value) => {
    // setTablesUsed([]);
    setPlaceOfTable(value);
    // setSelectedTablesSave([]);
    // setUsedTablesDic({});
  };

  const handlePeopleChange = (value) => {
    setNumPeople(value);
  };

  const handleBabyChange = (value) => {
    setNumBabyChairs(value);
  };

  const handleBabyReset = (value) => {
    setNumBabyChairs(0);
  };

  useEffect(() => {
    if (
      reservation_created &&
      currentStep >= 4 &&
      reservation_created.token &&
      !from_restaurant &&
      createReservationFailed === false
    ) {
      navigate(
        `/customer_reservation_menu/${reservation_created.token}/await_confirmation`,
      );
    }
  }, [currentStep, reservation_created]);

  const handleGoToReservation = (token, e) => {
    e.preventDefault();
    navigate(`/c/${token}/yes`);
  };

  const handleGoToReservationWhenEdited = () => {
    navigate(
      `/customer_reservation_menu/${editReservation.token}/await_confirmation`,
    );
  };

  const handleGoBackToReservationsRestaurantMenu = () => {
    navigate(`/reservationfromrestaurant/${restaurant_id}`);
  };

  const handleNotificationSubscription = (sub) => {
    setSubscription(sub);
  };

  useEffect(() => {
    if (countryCodeNumber && phoneWithoutCountryCode.length >= 0) {
      setPhone(String(countryCodeNumber) + String(phoneWithoutCountryCode));
    }
  }, [phoneWithoutCountryCode, countryCodeNumber]);

  const handleTermsAndConditionsFalse = () => {
    setShowTermsAndConditions(false);
  };

  const handleOpenDateModal = () => {
    setShowDateModal(true);
  };

  const handleCloseDateModal = () => {
    setShowDateModal(false);
  };

  useEffect(() => {
    if (
      openTime &&
      Array.isArray(openTime.zones) &&
      creating &&
      from_restaurant
    ) {
      let foundZoneWithoutF = false;
      let foundShiftWithoutF = false;

      if (!foundZoneWithoutF) {
        setFullRestaurant(true);
      } else {
        setFullRestaurant(false);
      }
    }
  }, [openTime, numPeople]);

  const handleExtras = (value) => {
    setIsExtrasOpen(!isExtrasOpen);
  };

  const handleTablesUsedChange = (value) => {
    setTablesUsed(value);
  };

  const handleCancel = () => {
    if (reservation) {
      dispatch(fetchCancelReservation(reservation.id));
    }
    setIsEditModalOpen(false);
    setShowModal(false);
    setTokens("");
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const changeDate = (date) => {
    setStartDate(date);
    setCurrentStep(1);
  };

  const chooseNumberOfPeople = (number_of_people) => {
    setNumPeople(number_of_people);
    if (reservation_or_waiting_list === "waiting_list") {
      setCurrentStep(3);
    } else {
      setCurrentStep(2);
    }
  };

  const changeTime = (time) => {
    setTime(time);
    setCurrentStep(3);
  };

  function extractNumbers(dictionary) {
    const numbers = [];

    Object.keys(dictionary).forEach((key) => {
      const array = dictionary[key];

      array.forEach((item) => {
        if (item.number) {
          numbers.push(item.number);
        }
      });
    });

    return numbers;
  }

  useEffect(() => {
    const formatDateToYYYYMMDD = (date) => {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    let formattedStartDate = formatDateToYYYYMMDD(startDate);

    if (
      openTime &&
      openTime.opentime_per_zone &&
      !isLoadingAllTables &&
      !isLoadingReservation
    ) {
      let isChangesTable = false;

      if (selectedTablesSave && reservation) {
        const table_numbers_to_compare = extractNumbers(selectedTablesSave);

        const tables_used_list = reservation.tablesused
          .split(",")
          .map((num) => num.trim())
          .filter((num) => num);

        const hasExtraTables = tables_used_list.some(
          (tableNumber) => !table_numbers_to_compare.includes(tableNumber),
        );

        const hasMissingTables = table_numbers_to_compare.some(
          (tableNumber) => !tables_used_list.includes(tableNumber),
        );

        if (hasExtraTables || hasMissingTables) {
          isChangesTable = true;
          setIsTablesChangedManually(true);
        } else {
          isChangesTable = false;
          setIsTablesChangedManually(false);
        }
      }

      let isDifferent = false;
      if (reservation) {
        formattedStartDate = formatDateToYYYYMMDD(startDate);
        isDifferent =
          reservation.date !== formattedStartDate ||
          reservation.number_of_people !== numPeople ||
          (reservation.table_place_preference?.place_of_table &&
            reservation.table_place_preference.place_of_table !==
              placeOfTable) ||
          reservation.time !== time ||
          reservation.full_name !== fullName ||
          reservation.email !== email ||
          reservation.phone_number !== phone ||
          reservation.baby_chair !== numBabyChairs ||
          reservation.restaurant_note != restaurantNote;
      }

      if (isDifferent || isChangesTable) {
        setIsReservationChanged(true);
      } else {
        setIsReservationChanged(false);
      }

      const diffs = [];
      const cmp = (label, a, b) => {
        const A = (a ?? "").toString().trim();
        const B = (b ?? "").toString().trim();
        if (A !== B) diffs.push({ label, A, B });
      };

      if (reservation) {
        cmp("date", reservation.date, formattedStartDate);
        cmp("people", reservation.number_of_people, Number(numPeople));
        cmp(
          "place",
          reservation.table_place_preference?.place_of_table,
          placeOfTable,
        );
        cmp("time", reservation.time, time);
        cmp("name", reservation.full_name, fullName);
        cmp("email", reservation.email, email);
        cmp("phone", reservation.phone_number, phone);
        cmp("baby_chair", reservation.baby_chair, Number(numBabyChairs));
        cmp(
          "accessability",
          reservation.accessability,
          accessability || "not_needed",
        );
        cmp(
          "restaurant_note",
          reservation.restaurant_note ?? "",
          restaurantNote ?? "",
        );
      }

      if (diffs.length || isChangesTable || creating) {
        console.log("MARKED MODIFIED BECAUSE:", {
          diffs,
          isChangesTable,
          creating,
        });
      }

      if (isDifferent || isChangesTable || creating) {
        if (typeof setModalReservationModifyReservation === "function") {
          setReservationHasBeenModified(true);
        }

        for (const x of openTime.opentime_per_zone[
          placeOfTable.endsWith("/f") || placeOfTable.endsWith("/b")
            ? placeOfTable.slice(0, -2)
            : placeOfTable
        ] || []) {
          let cleanTime = x.replace(/\/[fb]$/, "");
          if (cleanTime === time) {
            if (x.endsWith("/f")) {
              setFullyBooked(true);
              setIsAlertFullyBookedOrCrowd(true);
            } else if (x.endsWith("/b")) {
              setFullyBooked(false);
              setIsAlertFullyBookedOrCrowd(true);
            } else {
              setIsAlertFullyBookedOrCrowd(false);
            }
          }
        }

        setIsChangesMade(true);
      } else {
        if (typeof setModalReservationModifyReservation === "function") {
          setReservationHasBeenModified(false);
        }

        setIsChangesMade(false);
        setIsAlertFullyBookedOrCrowd(false);
      }
    }
  }, [
    fullName,
    email,
    phone,
    numPeople,
    placeOfTable,
    startDate,
    time,
    token,
    openTime,
    reservation,
    selectedTablesSave,
    numBabyChairs,
    accessability,
    restaurantNote,
  ]);

  return (
    <WidgetScreenFrame
      $widgetMode={widgetMode}
      $backgroundColor={widgetSettings.backgroundColor}
      $widgetDark={widgetDark}
    >
      {(creating || isEditModalOpen) && !initialLoading ? (
        <>
          {showCheck && (
            <ContainerCheck>
              <ModalBackgroundCheck>
                <ToastContainer />
                <AnimatedCheck />
              </ModalBackgroundCheck>
            </ContainerCheck>
          )}

          <>
            <Wrapper
              no_border={no_border}
              from_restaurant={from_restaurant}
              $widgetMode={widgetMode}
              $backgroundColor={widgetSettings.backgroundColor}
              $mainColor={widgetSettings.mainColor}
              $radius={widgetSettings.radius}
            >
              {widgetMode && !from_restaurant ? (
                <WidgetHeading>
                  <WidgetCustomTitle $mainColor={widgetSettings.mainColor}>
                    {widgetSettings.title}
                  </WidgetCustomTitle>

                  {widgetSettings.showRestaurantName && (
                    <Title
                      $widgetMode={widgetMode}
                      $mainColor={widgetSettings.mainColor}
                    >
                      {restaurants ? restaurants.restaurant_name : <Loader />}
                    </Title>
                  )}
                </WidgetHeading>
              ) : (
                <>
                  {creating && !from_restaurant && (
                    <>
                      <h5>Nova reserva</h5>

                      <Title
                        $widgetMode={widgetMode}
                        $mainColor={widgetSettings.mainColor}
                      >
                        {restaurants ? restaurants.restaurant_name : <Loader />}
                      </Title>
                    </>
                  )}
                </>
              )}

              <StepBar
                time={time}
                startDate={startDate}
                numPeople={numPeople}
                setNumPeople={setNumPeople}
                changeStep={changeStep}
                currentStep={currentStep}
                placeOfTable={placeOfTable}
                reservation_or_waiting_list={reservation_or_waiting_list}
                timezone={restaurants ? restaurants.timezone : "Europe/Lisbon"}
                from_restaurant={from_restaurant}
                creating={creating}
                mainColor={widgetSettings.mainColor}
              />

              <StyledCard
                from_restaurant={from_restaurant}
                $widgetMode={widgetMode}
                $backgroundColor={widgetSettings.backgroundColor}
              >
                {currentStep === 0 && (
                  <CustomDatePicker
                    selectedDate={startDate}
                    onDateChange={(date) => changeDate(date)}
                    id={restaurant_id}
                    mainColor={widgetSettings.mainColor}
                    widgetDark={
                      widgetSettings.backgroundColor === "#FFFFFF"
                        ? false
                        : true
                    }
                  />
                )}

                {currentStep === 1 && (
                  <NumberOfPeopleSelector
                    numPeople={numPeople}
                    setNumPeople={chooseNumberOfPeople}
                    from_restaurant={from_restaurant}
                    limit_people_reservation={
                      restaurants.limit_people_reservation
                    }
                    widgetMode={widgetMode}
                    widgetDark={
                      widgetSettings.backgroundColor === "#FFFFFF"
                        ? false
                        : true
                    }
                  />
                )}

                {currentStep === 2 && (
                  <Row>
                    <Col
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          borderBottom: "1px solid #99B0AD",
                          paddingBottom: "3px",
                          marginBottom: "3px",
                          color: "#99B0AD",
                          width: "200px",
                          height: "25px",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faHouse}
                          style={{ color: "#99B0AD" }}
                        />{" "}
                        Sala
                      </div>
                    </Col>

                    <Col
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {openTime && (
                        <CustomSelect
                          items={
                            reservation_or_waiting_list === "waiting_list"
                              ? openTime?.zones && [
                                  "Não definir sala",
                                  ...openTime.zones,
                                ]
                              : openTime.zones
                          }
                          onSelectChange={handlePlaceOfTable}
                          selectedItem={placeOfTable}
                          setUpdate={setUpdate}
                          update={update}
                          from_restaurant={from_restaurant}
                          widgetDark={
                            widgetSettings.backgroundColor === "#FFFFFF"
                              ? false
                              : true
                          }
                        />
                      )}
                    </Col>

                    {reservation_or_waiting_list === "reservation" &&
                      openTime && (
                        <Row
                          style={{ margin: "0", padding: "0", width: "100%" }}
                        >
                          <Col
                            xs={12}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                borderBottom: "1px solid #99B0AD",
                                paddingBottom: "3px",
                                color: "#99B0AD",
                                width: "200px",
                                height: "25px",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faClock}
                                style={{ color: "#99B0AD" }}
                              />{" "}
                              Horas
                            </div>
                          </Col>

                          <Col
                            xs={12}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              paddin: "0",
                              margin: "0",
                            }}
                          >
                            <ChooseTime
                              options={openTime.opentime_per_zone}
                              onTimeChange={handleTimeChange}
                              time={time}
                              timezone={restaurants.timezone}
                              current_date={startDate}
                              setTime={setTime}
                              currentZone={
                                placeOfTable.endsWith("/f")
                                  ? placeOfTable.slice(0, -2)
                                  : placeOfTable
                              }
                              editingStartFalse={editingStartFalse}
                              reservation={reservation}
                              update={update}
                              from_restaurant={from_restaurant}
                              true_create_false_edit={creating}
                              changeTime={changeTime}
                              people_per_time={openTime.people_per_time}
                              placeOfTable={placeOfTable}
                              startDate={startDate}
                              numPeople={numPeople}
                              token={token}
                              showModalWarning={showModalWarning}
                              setShowModalWarning={setShowModalWarning}
                              fullyBooked={fullyBooked}
                              setFullyBooked={setFullyBooked}
                              widgetMode={widgetMode}
                              widgetDark={
                                widgetSettings.backgroundColor === "#FFFFFF"
                                  ? false
                                  : true
                              }
                            />
                          </Col>
                        </Row>
                      )}
                  </Row>
                )}

                {currentStep === 3 && (
                  <>
                    <StepThreeReservations
                      fullName={fullName}
                      setFullName={setFullName}
                      countryCodeNumber={countryCodeNumber}
                      setCountryCodeNumber={setCountryCodeNumber}
                      phoneWithoutCountryCode={phoneWithoutCountryCode}
                      setPhoneWithoutCountryCode={setPhoneWithoutCountryCode}
                      Extras={Extras}
                      isExtrasOpen={isExtrasOpen}
                      handleExtras={handleExtras}
                      babyChairs={babyChairs}
                      DivFlexStart={DivFlexStart}
                      setBabyChairs={setBabyChairs}
                      DivFlexEnd={DivFlexEnd}
                      ScrollInputOptions={ScrollInputOptions}
                      numBabyChairs={numBabyChairs}
                      existingBabyChairs={restaurants?.number_of_babychairs}
                      handleBabyChange={handleBabyChange}
                      limitPeopleBaby={limitPeopleBaby}
                      isMessageOpen={isMessageOpen}
                      setIsMessageOpen={setIsMessageOpen}
                      isAccessOpen={isAccessOpen}
                      message={message}
                      setMessage={setMessage}
                      maxMessageLength={maxMessageLength}
                      CustomSelect={CustomSelect}
                      accessabilities={accessabilities}
                      setIsAccessOpen={setIsAccessOpen}
                      setAccessability={setAccessability}
                      ActionButtons={ActionButtons}
                      goBack={goBack}
                      accessability={accessability}
                      setShowTermsAndConditions={setShowTermsAndConditions}
                      handleSubmit={handleSubmit}
                      handleEdit={handleEdit}
                      phoneWS={phoneWS}
                      setEmail={setEmail}
                      email={email}
                      emailWS={emailWS}
                      fullNameWS={fullNameWS}
                      true_create_false_edit={creating}
                      acceptTerms={acceptTerms}
                      setAcceptTerms={setAcceptTerms}
                      acceptTermsWS={acceptTermsWS}
                      from_restaurant={from_restaurant}
                      creating={creating}
                      handleShowModal={handleShowModal}
                      restaurantNote={restaurantNote}
                      setRestaurantNote={setRestaurantNote}
                      widgetMode={widgetMode}
                      widgetDark={
                        widgetSettings.backgroundColor === "#FFFFFF"
                          ? false
                          : true
                      }
                      mainColor={widgetSettings.mainColor}
                    />

                    {!from_restaurant && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "12px",
                          width: "100%",
                          marginTop: "1rem",
                          flexWrap: "nowrap",
                        }}
                      >
                        {creating ? (
                          <>
                            {creating && !from_restaurant && (
                              <TermsBox
                                $invalid={!!acceptTermsWS}
                                $widgetMode={widgetMode}
                                style={{
                                  width: "auto",
                                  flex: "1 1 0",
                                  minWidth: 0,
                                  margin: 0,
                                }}
                              >
                                <TermsContent
                                  $widgetMode={widgetMode}
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={acceptTerms}
                                    onChange={() =>
                                      setAcceptTerms(!acceptTerms)
                                    }
                                  />
                                  <span
                                    style={{
                                      minWidth: 0,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Li e aceito os{" "}
                                    <a
                                      onClick={(event) => {
                                        event.preventDefault();
                                        setShowTermsAndConditions(true);
                                      }}
                                    >
                                      Termos e Condições
                                    </a>
                                    .
                                  </span>
                                </TermsContent>
                              </TermsBox>
                            )}

                            <div
                              style={{
                                flex: "0 0 auto",
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <ModernButton
                                color={
                                  widgetMode
                                    ? widgetSettings.mainColor
                                    : "#EE754C"
                                }
                                onClick={(e) => handleSubmit(e)}
                                style={{
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Solicitar reserva
                              </ModernButton>
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <ModernButton
                              color={
                                widgetMode
                                  ? widgetSettings.mainColor
                                  : "#EE754C"
                              }
                              onClick={(e) => handleEdit(e)}
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              Solicitar Alteração de reserva
                            </ModernButton>
                          </div>
                        )}
                      </div>
                    )}

                    <div style={{ width: "100%", justifyContent: "start" }}>
                      {creating && from_restaurant && (
                        <CustomSelect
                          items={[
                            "Atribuição automática de mesas",
                            "Atribuição manual de mesas",
                          ]}
                          onSelectChange={setAutoOrManualTables}
                          selectedItem={autoOrManualTables}
                        />
                      )}
                    </div>

                    {!isLoading &&
                    !isLoadingEditReservation &&
                    !isLoadingOpenTime &&
                    !isLoadingReservation &&
                    !isLoadingAllTables &&
                    !initialLoading ? (
                      <>
                        {numPeople !== 0 &&
                          from_restaurant &&
                          autoOrManualTables ===
                            "Atribuição manual de mesas" && (
                            <>
                              {Array.isArray(tablesUsed) && (
                                <TablesWrapper>
                                  <TableSvgIcon
                                    width={30}
                                    height={30}
                                    strokeColor="#99B0AD"
                                  />
                                  {Array.isArray(tablesUsed) &&
                                    tablesUsed[0] !== "" &&
                                    tablesUsed.length > 0 &&
                                    tablesUsed
                                      .map((num) => parseInt(num, 10))
                                      .sort((a, b) => a - b)
                                      .map((tableNumber) => {
                                        const tableObj = all_tables?.find(
                                          (table) => table.id === tableNumber,
                                        );
                                        return tableObj
                                          ? tableObj.table_name
                                          : tableNumber;
                                      })
                                      .join(", ")}

                                  <ModernButton
                                    color="#99B0AD "
                                    onClick={handleShowTablesModal}
                                  >
                                    Mesas
                                  </ModernButton>
                                </TablesWrapper>
                              )}
                            </>
                          )}

                        <div style={{ width: "100%" }}>
                          {reservation &&
                            isWithinOneDay(reservation.date) &&
                            from_restaurant && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  gap: "10px",
                                  flexWrap: "wrap",
                                  width: "100%",
                                  marginTop: "1rem",
                                }}
                              >
                                {!creating && (
                                  <ModernButton
                                    color="#99B0AD"
                                    onClick={(e) => handleShowModal(e)}
                                  >
                                    Cancelar reserva
                                  </ModernButton>
                                )}

                                {isChangesMade && !creating && (
                                  <ModernButton
                                    color="#EE754C"
                                    onClick={(e) =>
                                      handleCheckWarningBeforeEdit(e)
                                    }
                                  >
                                    Guardar alterações
                                  </ModernButton>
                                )}
                              </div>
                            )}

                          {creating && from_restaurant && (
                            <>
                              {verifyReservationFields ? (
                                <ModernButton
                                  color="#EE754C"
                                  onClick={(e) =>
                                    handleCheckWarningBeforeEdit(e)
                                  }
                                  style={{ marginTop: "1rem" }}
                                >
                                  Criar Reserva
                                </ModernButton>
                              ) : (
                                <>
                                  <ModernButton
                                    color="#99B0AD"
                                    style={{
                                      marginTop: "1rem",
                                      cursor: "not-allowed",
                                    }}
                                    disabled
                                  >
                                    Criar Reserva
                                  </ModernButton>
                                  <div
                                    className="text-red-500 mt-2"
                                    style={{
                                      marginTop: "0.5rem",
                                      color: "#f44336",
                                    }}
                                  >
                                    Para avançar é necessário completar os dados
                                    da reserva.
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </>
                    ) : (
                      <Loader />
                    )}
                  </>
                )}

                {currentStep === 4 && (
                  <>
                    {isLoading ? (
                      <h2>
                        <Loader />
                      </h2>
                    ) : error && error.error.includes("reservation-exists") ? (
                      <>
                        <h2>
                          <FontAwesomeIcon
                            size="xl"
                            icon={faTriangleExclamation}
                            style={{ color: "#f3e335", marginRight: "15px" }}
                          />
                          Já tens um pedido de reserva activo para este dia.
                        </h2>
                        <h5>Podes a acessar a reserva no botão abaixo.</h5>

                        <Button
                          className="mt-3"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleGoToReservation(error.error.split(";")[1], e);
                          }}
                        >
                          Aceder reserva
                          <FontAwesomeIcon
                            icon={faShareFromSquare}
                            style={{ color: "#ffffff", marginLeft: "5px" }}
                          />
                        </Button>
                      </>
                    ) : (
                      <h2>Por favor atualizar a página.</h2>
                    )}
                  </>
                )}
              </StyledCard>

              <TermsAndConditions
                showTermsAndConditions={showTermsAndConditions}
                setSetShowTermsAndConditions={handleTermsAndConditionsFalse}
              />
            </Wrapper>
          </>

          <ConfirmationModal
            show={showModalWarning}
            onHide={() => setShowModalWarning(false)}
            onConfirm={(e) => {
              setShowModalWarning(false);

              if (creating) {
                handleSubmit(e);
              } else {
                handleEdit(e);
              }
            }}
            title={"Mesas insuficientes"}
            body={
              <>
                {from_restaurant &&
                  !creating &&
                  (reservation.status === "pending_restaurant" ||
                    reservation.status === "edited") && (
                    <div style={{ paddingBottom: "10px" }}>
                      Aceitar reserva e notificar cliente
                      <SwitchOnAndOff
                        clienteAndOff
                        isOn={accept_and_notify_client}
                        handleToggle={() =>
                          setAccept_and_notify_client(!accept_and_notify_client)
                        }
                      />
                    </div>
                  )}

                {fullyBooked ? (
                  <div style={{ color: "red" }}>
                    A sala escolhida encontra-se lotada no horário selecionado.
                    <br />
                    Ao continuar não serão atribuídas mesas automaticamente.
                  </div>
                ) : (
                  <div style={{ color: "#d9c834" }}>
                    Cada horário disponível aceita até{" "}
                    {restaurants.accept_people_per_each_time} pessoas.
                    <br />
                    Ao continuar irá ultrapassar este limite pré-definido.
                    <br />
                    Alterar o número máximo de pessoas por horário nas
                    Definições.
                  </div>
                )}
              </>
            }
            confirmLabel={creating ? "Criar reserva" : "Guardar"}
            cancelLabel={fullyBooked ? "Ver mesas" : "Não avançar"}
            confirmColor="#EE754C"
            cancelColor={fullyBooked ? "#99B0AD" : "#EE754C"}
            onCancel={() => {
              setShowModalWarning(false);
              handleShowTablesModal(true);
            }}
          />

          <ConfirmationModal
            show={accept_edit_modal}
            onHide={() => setAccept_edit_modal(false)}
            onConfirm={(e) => {
              setAccept_edit_modal(false);
              handleEdit(e);
            }}
            title={"Mesas insuficientes"}
            body={
              <>
                Aceitar reserva e notificar cliente{" "}
                <SwitchOnAndOff
                  isOn={accept_and_notify_client}
                  handleToggle={() =>
                    setAccept_and_notify_client(!accept_and_notify_client)
                  }
                />
              </>
            }
            confirmLabel={"Guardar"}
            cancelLabel={"Não guardar"}
            confirmColor="#EE754C"
            cancelColor="#99b0ad "
            onCancel={() => {
              setAccept_edit_modal(false);
            }}
          />

          {showDateModal && (
            <ModalBackgroundToCustomDate>
              <CustomDateContainer onHide={handleCloseDateModal}>
                <CustomDatePicker
                  selectedDate={startDate}
                  onDateChange={(date) => changeDate(date)}
                  id={restaurant_id}
                  handleCloseDateModal={handleCloseDateModal}
                  mainColor={widgetSettings.mainColor}
                />
              </CustomDateContainer>
            </ModalBackgroundToCustomDate>
          )}

          {showTablesModal && <ModalOverlay />}

          {tables && (
            <TablesModal
              show={showTablesModal}
              tables_list={tables}
              onClose={() => setShowTablesModal(false)}
              initialSelectedTables={usedTablesDic}
              token={token}
              id={restaurant_id}
              numPeople={numPeople}
              time={time}
              date={startDate}
              handleTablesUsedChange={handleTablesUsedChange}
              setSelectedTablesSave={(value) => setSelectedTablesSave(value)}
              setPlaceOfTable={(value) => setPlaceOfTable(value)}
              setEnoughSeatsReservation={setEnoughSeatsReservation}
              placeOfTable={placeOfTable}
              reservation={reservation}
            />
          )}

          <ConfirmationModal
            show={showModal}
            onHide={handleCloseModal}
            onConfirm={handleCancel}
            title="Eliminar reserva"
            body="Tens a certeza que pretendes eliminar esta reserva?"
            confirmLabel={isLoadingCancel ? <Loader /> : "Eliminar reserva"}
            cancelLabel="Não eliminar"
            confirmColor="#ee754c"
            cancelColor="#99B0AD"
          />

          <ConfirmationModal
            show={modalReservationModifyReservation}
            onHide={() => {
              setModalReservationModifyReservation(false);
              setIsEditModalOpen(false);
            }}
            onConfirm={(e) => {
              setModalReservationModifyReservation(false);
              handleEdit(e);
            }}
            title="Alterações por guardar"
            body="As alterações à reserva ainda não foram guardadas."
            confirmLabel="Guardar alterações"
            cancelLabel="Fechar sem guardar"
            confirmColor="#ee754c"
            cancelColor="#99B0AD"
          />

          <ConfirmationModal
            show={notifyCustomerModal}
            onHide={() => {
              if (isSubmittingNotifyChoice) return;
              setNotifyCustomerModal(false);
            }}
            title="Notificar cliente?"
            body={
              <>
                A reserva foi alterada pelo restaurante.
                <br />
                Deseja enviar uma mensagem ao cliente com a alteração?
              </>
            }
            cancelLabel={
              isSubmittingNotifyChoice ? "A guardar..." : "Guardar sem avisar"
            }
            confirmLabel={
              isSubmittingNotifyChoice
                ? "A enviar..."
                : "Sim, notificar cliente"
            }
            cancelColor="#99B0AD"
            confirmColor="#EE754C"
            onCancel={() => handleNotifyCustomerChoice(false)}
            onConfirm={() => handleNotifyCustomerChoice(true)}
          />

          <ConfirmationModal
            show={modalWarningNotEnoughSeats}
            onHide={() => setModalWarningNotEnoughSeats(false)}
            onConfirm={(e) => {
              setModalWarningNotEnoughSeats(false);

              if (creating) {
                handleSubmit(e);
              } else {
                handleEdit(e);
              }
            }}
            title={<>Mesas insuficientes</>}
            body={
              <>
                {from_restaurant &&
                  !creating &&
                  (reservation.status === "pending_restaurant" ||
                    reservation.status === "edited") && (
                    <div style={{ paddingBottom: "10px" }}>
                      Aceitar reserva e notificar cliente{" "}
                      <SwitchOnAndOff
                        isOn={accept_and_notify_client}
                        handleToggle={() =>
                          setAccept_and_notify_client(!accept_and_notify_client)
                        }
                      />
                    </div>
                  )}

                <div>Não foram atribuídas mesas suficientes.</div>
                <div>
                  Ao continuar não haverá lugares suficientes para todas as
                  pessoas da reserva.
                </div>
              </>
            }
            confirmLabel={creating ? "Criar reserva" : "Guardar"}
            cancelLabel="Ver mesas"
            confirmColor="#EE754C"
            cancelColor="#99B0AD"
            onCancel={() => {
              setModalWarningNotEnoughSeats(false);
              setShowTablesModal(true);
            }}
          />
        </>
      ) : initialLoading ? (
        <div
          style={{
            width: "100%",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Loader theSize="big" />
        </div>
      ) : (
        <></>
      )}
    </WidgetScreenFrame>
  );
};

export default ReservationScreen;

const TermsBox = styled.div`
  width: 100%;
  border: ${({ $invalid }) =>
    $invalid
      ? "1px solid #d94b4b"
      : "1px solid var(--widget-border-color, #d8dddb)"};
  border-radius: ${({ $widgetMode }) => ($widgetMode ? "8px" : "10px")};
  padding: ${({ $widgetMode }) => ($widgetMode ? "8px 9px" : "10px 12px")};
  box-sizing: border-box;
  background: ${({ $invalid }) =>
    $invalid ? "rgba(217, 75, 75, 0.04)" : "transparent"};
`;

const TermsContent = styled.label`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: 0;
  color: var(--widget-muted-text, #4f5f5b);
  font-size: ${({ $widgetMode }) => ($widgetMode ? "12px" : "14px")};
  line-height: 1.35;
  cursor: pointer;

  input {
    flex: 0 0 auto;
    margin-top: 2px;
  }

  span {
    min-width: 0;
  }

  a {
    color: var(--widget-main-color, #ee754c);
    cursor: pointer;
    text-decoration: underline;
    font-weight: 650;
  }

  @media (max-width: 420px), (max-height: 640px) {
    font-size: 12px;
  }
`;
